import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Container, Typography } from '@material-ui/core';

// Styles
const useStyles = makeStyles((theme) => ({
  overlayText: {
    width: '30vw',
    position: 'absolute',
    textAlign: 'left',
    top: '35vh',
    left: '60vw',
    zIndex: 101,
  },
  backgroundBox: {
    width: '60%',
    top: '-150px',
    padding: theme.spacing(4),
    backgroundColor: theme.palette.alternative.main,
    zIndex: 101,
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  servicesText: {
    color: theme.palette.interactive.main,
    textTransform: 'uppercase',
  },
  title: {
    color: theme.palette.primary.main,
    fontWeight: 600,
  },
  heroImage: {
    position: 'relative',
    display: 'block',
    zIndex: 100,
    height: '500px',
    '&:after': {
      position: 'absolute',
      content: '""',
      top: 0,
      left: 0,
      right: 0,
      width: '100%',
      height: '100%',
    },
  },
  imageTag: {
    display: 'inline-block',
    width: '100%',
    height: '100%',
    layout: 'fill',
    objectFit: 'cover',
  },
}));

const Hero = (props) => {
  const classes = useStyles();
  const { data } = props;

  return (
    <Box>
      <Box className={classes.heroImage}>
        <img
          src={data ? data.picture.url : '/'}
          className={classes.imageTag}
          alt="Hero"
        />
      </Box>
      <Container maxWidth="lg">
        <Box className={classes.backgroundBox}>
          <Typography variant="h6" className={classes.servicesText}>SERVICES</Typography>
          <Typography variant="h4" className={classes.title}>{data ? data.title : '-'}</Typography>
          <Typography>{data ? data.preamble : '-'}</Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Hero;
